"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SourceSvc = void 0;
var get_1 = __importDefault(require("lodash/get"));
var helpers_1 = require("@companydotcom/helpers");
var app_sync_client_1 = require("../app-sync-client");
var source_query_1 = __importDefault(require("./graphql/source-query"));
var isEnabled = process.env.REACT_APP_CACHE_ENABLED === 'true' || false;
var getSource = (0, helpers_1.withCache)(function (sourceId, locale) {
    if (locale === void 0) { locale = 'en'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, source;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                        query: source_query_1["default"].getSource(sourceId, locale)
                    })];
                case 1:
                    res = _a.sent();
                    source = (0, get_1["default"])(res, 'data.getSource');
                    return [2 /*return*/, source];
            }
        });
    });
}, 'source', undefined, isEnabled);
var getSourceURI = (0, helpers_1.withCache)(function (uri) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                    query: source_query_1["default"].getSourceURI(uri)
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, (0, get_1["default"])(res, 'data.getSourceURI.sourceId')];
        }
    });
}); }, 'sourceURI', undefined, isEnabled);
/**
 * @deprecated MOVED TO PAYMENT API
 * @param sourceId
 * @param isLocal
 * @returns
 */
var getPaymentForm = function (sourceId, isLocal) {
    if (isLocal === void 0) { isLocal = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, app_sync_client_1.companyQL.query({
                            query: source_query_1["default"].getPaymentForm(sourceId, isLocal)
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data.getPaymentForm || null];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, err_1];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/**
 * @deprecated MOVED TO PAYMENT API
 * @param accountId
 * @param productId
 * @param locale
 * @returns
 */
var getProductRatePlan = function (accountId, productId, locale) {
    if (locale === void 0) { locale = 'en'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                        query: source_query_1["default"].getProductRatePlan(accountId, productId, locale)
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data.getProductRatePlan];
            }
        });
    });
};
var getSourceConfig = (0, helpers_1.withCache)(function (sourceId) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                    query: source_query_1["default"].getSourceConfig(sourceId)
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.getSourceConfig];
        }
    });
}); }, 'externalIdentifier', undefined, isEnabled);
var getAuth0Config = (0, helpers_1.withCache)(function (source) {
    if (source === void 0) { source = 'company'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                        query: source_query_1["default"].getAuth0Config(source)
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data.getAuth0Config];
            }
        });
    });
}, 'externalIdentifier', undefined, isEnabled);
var getContactInformation = function (sourceId) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, app_sync_client_1.companyQL.query({
                    query: source_query_1["default"].getContactInformation(sourceId)
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
var SourceSvc = function () { return ({
    getSource: getSource,
    getSourceURI: getSourceURI,
    getPaymentForm: getPaymentForm,
    getProductRatePlan: getProductRatePlan,
    getSourceConfig: getSourceConfig,
    getAuth0Config: getAuth0Config,
    getContactInformation: getContactInformation
}); };
exports.SourceSvc = SourceSvc;
